'use client';

import { ProviderType, type TrackingEvent } from '@/reporting/types';
import logger from '@/utils/client-logger';
import {
  buildMeasurementTrackingProperties,
  MEASUREMENT_TRACKING_EVENT,
  resolveMeasurementInteractionReview,
  type MeasurementTrackingContext,
} from './tracking';

type SensorsTrackEvent = (event: TrackingEvent, providers: ProviderType[]) => void;

function reportToSensors(trackEvent: SensorsTrackEvent, event: TrackingEvent) {
  try {
    trackEvent(event, [ProviderType.SENSORS]);
  } catch (error) {
    logger.warn(`[MeasurementTracking] Failed to report ${event.eventName}`, error);
  }
}

export function reportMeasurementPageView(
  trackEvent: SensorsTrackEvent,
  context: MeasurementTrackingContext,
) {
  reportToSensors(trackEvent, {
    eventName: MEASUREMENT_TRACKING_EVENT.pageView,
    properties: buildMeasurementTrackingProperties(context),
  });
}

export function reportMeasurementButtonClick(
  trackEvent: SensorsTrackEvent,
  context: MeasurementTrackingContext,
  buttonName: string,
) {
  reportToSensors(trackEvent, {
    eventName: MEASUREMENT_TRACKING_EVENT.buttonClick,
    properties: {
      ...buildMeasurementTrackingProperties(context),
      btn_name: buttonName,
    },
  });
}

export function reportMeasurementInteractionClick(
  trackEvent: SensorsTrackEvent,
  context: MeasurementTrackingContext,
  feedback: 'like' | 'dislike' | undefined,
) {
  reportToSensors(trackEvent, {
    eventName: MEASUREMENT_TRACKING_EVENT.interactionClick,
    properties: {
      ...buildMeasurementTrackingProperties(context),
      interaction_review: resolveMeasurementInteractionReview(feedback),
    },
  });
}
